import { render, staticRenderFns } from "./NarliFerryboatStatsByPlateTotalGraph.vue?vue&type=template&id=608385c0&"
import script from "./NarliFerryboatStatsByPlateTotalGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByPlateTotalGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports